// extracted by mini-css-extract-plugin
module.exports = {"t4tqfsr":"t4tqfsr"};